<template>
    <transition>
        <div
            v-if="showModal"
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-70 flex justify-center items-center"
        >
            <div
                v-if="status == 'chose'"
                class="modal-container bg-white w-4/12 rounded border-2 border-primary mb-5 pb:w-[609px] sm:min-w-[350px] pb:min-h-[500px]"
            >
                <div class="modal-content p-4 text-left">
                    <div class="flex justify-between items-center pb-3">
                        <p class="text-2xl font-bold text-primary">
                          Escolha um método de verificação
                        </p>
                        <div
                            class="modal-close cursor-pointer z-50"
                            @click="close"
                        >
                        <Icon name="Fechar" />
                        </div>
                    </div>
                    <p class="font-medium">
                      Para mantermos sua conta segura, precisamos garantir que é realmente você tentando acessar a conta:
                    </p>
                    <section class="flex flex-col gap-y-2 mt-10">
                      <div v-for="credentialauthenticationmethod in credentialauthenticationmethods"
                        @click="setSelectedAuthenticationMethod(credentialauthenticationmethod.id)"
                        :key="credentialauthenticationmethod.id"
                        :class="{ 'pointer-events-none': isLoadingAuthenticationMethod }"
                        class="w-full grid authorization-option-grid gap-x-2 cursor-pointer">
                        <Icon name="email" fill="black"/>
                        <label class="transition-all relative mb-1 mr-5 flex flex-col gap-y-1 w-full cursor-pointer">
                          <p class="text-sm">Receber um código de verificação no e-mail:</p>
                          <p class="font-bold">{{ credentialauthenticationmethod.contact }}</p>
                        </label>
                      </div>
                    </section>
                </div>
            </div>

            <div
                v-else-if="status == 'ok'"
                class="modal-container bg-white w-4/12 rounded border-2 border-primary mb-5 pb:w-[609px] sm:min-w-[350px]"
            >
                <div class="modal-content p-4 text-left">
                    <div class="flex justify-between items-center pb-3">
                        <p class="text-2xl font-bold text-primary">
                          Verificação em 2 etapas
                        </p>
                        <div
                            class="modal-close cursor-pointer z-50"
                            @click="close"
                        >
                        <Icon name="Fechar" />
                        </div>
                    </div>
                    <p class="font-medium">
                        Para mantermos sua conta segura, precisamos garantir que é realmente você tentando acessar a conta:
                    </p>
                    <section class="flex flex-column gap-y-2 mt-10">
                      <div class="w-full">
                        <label class="transition-all relative mb-1 mr-5 flex flex-col gap-y-1 w-full">
                          <p class="text-sm">Digite o código enviado para o e-mail:</p>
                          <p class="font-bold">{{ selectedCredentialAuthenticationMethod.contact }}</p>
                        </label>
                      </div>
                    </section>
                    <section class="flex flex-column gap-y-2 mt-2">
                      <div class="w-full">
                        <label @click="() => resendTimerEnabled && resendAuthorizationAttempt()"
                          class="transition-all relative mb-1 mr-5 flex flex-col gap-y-1 w-full"
                          :class="{'cursor-pointer': resendTimerEnabled}">
                          <p class="text-sm">Reenviar código para o e-mail em {{ String(enableResendTimer) }}s</p>
                        </label>
                      </div>
                    </section>
                </div>
                <form @submit.prevent="validateAuthorizationAttempt">
                    <div class="mx-2.5 w-2.5/12 xl:px-12 xl:py-8 px-4 py-2 leading-9">
                        <div
                            v-if="error"
                            class="flashError text-[10px] text-error"
                        >
                            {{ error }}
                        </div>
                        <div class="flex border-2 border-primary">
                            <input
                                class="hover:bg-gray-600 self-start w-full p-2"
                                id="code"
                                name="code"
                                v-model="code"
                            >
                        </div>
                        <Button class="py-0 xl:mt-8 mt-4" :disabled="disabledSubmitButton">
                            Enviar
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import Icon from "@/Components/UI/Icons/Icon.vue"
import axios from "axios";
import getBrowserFingerprint from "get-browser-fingerprint";
import Button from "@/Components/Button.vue";

export default{
  components:{
    Icon,
    Button,
  },
  emits: ['onCancel', 'onSuccess'],
  props: {
    guest: Boolean,
    showModal: Boolean,
    accessTo: String,
    defaultCredentialAuthorizationId: String,
    defaultCredentialAuthenticationMethodId: String,
    defaultContact: String,
    credentialauthenticationmethods: {
      default: [],
      type: Array
    },
  },
  data(){
    return {
      status: '',
      error: '',
      code: '',
      selectedAuthenticationMethod: '',
      credentialauthenticationmethodId: undefined,
      credentialauthorizationId: "",
      sendedAt: undefined,
      enableResendTimer: 0,
      isLoadingAuthenticationMethod: false,
      disabledSubmitButton: false,
    }
  },
  mounted() {
    this.mount();
  },
  watch: {
    enableResendTimer: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.enableResendTimer--;
          }, 1000);
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  },
  computed: {
    resendTimerEnabled() {
      return this.enableResendTimer < 1 ? true : false;
    },
    browserFingerprint() {
      return getBrowserFingerprint();
    },
    sendedAtDurationInSeconds() {
      return
    },
    selectedCredentialAuthenticationMethod() {
      if (this.defaultContact) {
        return {
          id: this.defaultCredentialAuthenticationMethodId,
          contact: this.defaultContact,
        }
      }
      return this.credentialauthenticationmethods.find(item => {
        return item.id == this.credentialauthenticationmethodId;
      })
    }
  },
  methods: {
    setSelectedAuthenticationMethod(newSelection) {
      this.credentialauthenticationmethodId = newSelection;
      this.requestAuthorizationAttempt();
    },
    async requestAuthorizationAttempt() {
        this.isLoadingAuthenticationMethod = true;
        const requestData = {
            accessTo: this.accessTo ?? 'teste',
            credentialauthenticationmethodId: this.credentialauthenticationmethodId,
            fingerprintHash: this.browserFingerprint,
        }

        const { data: credentialauthorization } = await axios.post(
            this.guest?
            this.route('mfa.request-authorization-guest'):
            this.route('mfa.request-authorization'),
            requestData
        );

        this.credentialauthorizationId = credentialauthorization.id;

        this.status = 'ok';
        this.enableResendTimer = 30;
        this.isLoadingAuthenticationMethod = false;
    },
    async validateAuthorizationAttempt() {
      this.disabledSubmitButton = true;
      const requestData = {
        code: this.code,
        credentialauthorizationId: this.credentialauthorizationId,
      }

      const { data: credentialauthorization } = await axios.post(this.route('mfa.validate-authorization'), requestData);

      if (credentialauthorization) {
        this.authorized();
      } else {
        this.error = `Código inválido, tente novamente.`;
        this.disabledSubmitButton = false;
      }
    },
    async resendAuthorizationAttempt() {
      if(this.enableResendTimer > 0) return;

      const requestData = {
        credentialauthorizationId: this.credentialauthorizationId,
        accessTo: this.accessTo ?? 'teste',
        credentialauthenticationmethodId: this.credentialauthenticationmethodId,
        fingerprintHash: this.browserFingerprint,
      }

      this.enableResendTimer = 30;
      const { data: credentialauthorization } = await axios.post(this.route('mfa.resend-authorization'), requestData);
    },
    mount() {
      const hasAuthenticationMethodSelected = this.defaultCredentialAuthenticationMethodId && this.defaultCredentialAuthorizationId;

      if(hasAuthenticationMethodSelected) {
        this.status = 'ok';
        this.credentialauthenticationmethodId = this.defaultCredentialAuthenticationMethodId;
        this.credentialauthorizationId = this.defaultCredentialAuthorizationId;
        this.enableResendTimer = 30;
      } else {
        this.status = 'chose';
      }
    },
    close() {
      this.$emit('onCancel');
    },
    authorized() {
      this.$emit('onSuccess');
    },
  }
};

</script>
<style>
  .authorization-option-grid {
    grid-template-columns: min-content auto;
  }
</style>
